// import $ from 'jquery';

import { initMobileMenu } from './mobile-menu';
import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';
//import { invokeFlexSlider } from './flex-slider';
//import { newsArchive } from './news-archive';
import { initCleaveDate } from './cleave-date';
//import { initTMIdentity } from './tm-login';
import { configureAutoComplete } from './form-autocomplete/autocomplete';

// import 'slick-carousel';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import 'flexslider';

$(function () {
  initMobileMenu();
  paintMasonryLayout();
  initFancyInputBox();
  initInfiniteScroll();
  initStateDropDownBox();
  formValidationEvents();
  sizePicker();
  //invokeFlexSlider();
  //newsArchive();
  //initTMIdentity();
  initCleaveDate();

  configureAutoComplete();

  // const swishyMemu = $('.js-swisyMobileMenu');
  // swishyMemu.click(function(e) {
  //   e.preventDefault();
  //   swishyMemu.toggleClass('open');
  //   // swishyMemu.toggleClass('js-swishyMobileMenu__rotate');
  //   const mobileMenu = $('.js-mobileMenuContainer');
  //   mobileMenu.toggleClass("js-l-mobile");

  //   $('body').toggleClass("no-scroll");
  // });


});
